import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import Label from 'core/components/label/label';
import useStyles from './aor-run-detail.styles';

/** One policy row of an apply report: the P4 branch's `details` (#33090). */
const PolicyResultRow = ({ details, error, showError }) => {
  const classes = useStyles();
  const policyId = details.policyId ?? '—';
  const accountId = details.accountId || policyId.split('-')[0];

  return (
    <TableRow>
      <TableCell>
        <Link to={`/customer/${accountId}/policy/${policyId}`} target="_blank" rel="noopener noreferrer">
          <Label type="action" className={classes.tableLink}>
            {policyId}
          </Label>
        </Link>
      </TableCell>
      <TableCell>
        <Link to={`/customer/${accountId}`} target="_blank" rel="noopener noreferrer">
          <Label type="action" className={classes.tableLink}>
            {accountId}
          </Label>
        </Link>
      </TableCell>
      <TableCell>{details.nratOutcome ?? '—'}</TableCell>
      <TableCell>{details.letter ?? '—'}</TableCell>
      <TableCell>{details.oldAffinity || '—'}</TableCell>
      <TableCell>{details.affinityOutcome ?? '—'}</TableCell>
      <TableCell>{details.oldPrice ?? '—'}</TableCell>
      <TableCell>{details.newPrice ?? '—'}</TableCell>
      {showError && <TableCell className={classes.errorCell}>{error ?? '—'}</TableCell>}
    </TableRow>
  );
};

PolicyResultRow.propTypes = {
  details: PropTypes.object.isRequired,
  error: PropTypes.string,
  showError: PropTypes.bool
};

PolicyResultRow.defaultProps = {
  error: null,
  showError: false
};

export const policyResultVariant = {
  key: 'policies',
  label: 'policies',
  // "From" is the code this policy moved off: with N old codes -> 1 new, the report is the only record of it.
  columns: ['Policy', 'Account', 'NRAT', 'Letter', 'From', 'Affinity', 'Old price', 'New price'],
  rowKey: (details) => details.policyId,
  matches: (details) => Boolean(details.policyId),
  Row: PolicyResultRow
};

export default PolicyResultRow;
